/* eslint-disable */

<template>
  <div class="main">
    <div class="case-container">
      <div class="action-buttons">
        <button class="action-btn">?</button>
        <button class="action-btn" @click="redirectUser('home')">X</button>
      </div>

      <h2>Scenariusze</h2>
      <div class="tab-list">
        <button
          class="tab"
          id="sc-1"
          @click="selectCase(1)"
          :class="{ 'active-tab': activeCase == 1 }"
        >
          Kolektywizacja wsi polskiej
        </button>
        <button
          class="tab"
          id="sc-2"
          @click="selectCase(2)"
          :class="{ 'active-tab': activeCase == 2 }"
        >
          Czas w badaniach korpusowych: schemat katastrofy
        </button>
      </div>
      <!-- KOLEKTYWIZACJA -->
      <div class="case-body" :class="{ 'case-active': activeCase == 1 }">
        <div class="highlight">
          <h2>Kolektywizacja wsi polskiej</h2>
        </div>
        <div class="section">
          <h4>Czym była kolektywizacja?</h4>
          <div class="content">
            <div class="section-body">
              <p>
                Po roku 1945 władze komunistyczne dążyły do wprowadzania na
                terenie Rzeczpospolitej Polskiej (a po zmianie nazwy w 1952 roku
                – w Polskiej Rzeczpospolitej Ludowej) sowieckich wzorców
                gospodarczych. Jednym z nich była kolektywna gospodarka rolna,
                oparta na tzw. społecznej własności ziemi i maszyn oraz na
                dzieleniu się z państwem plonami i efektami hodowli, co w
                praktyce oznaczało system przymusowych dostaw dla państwa. W
                ZSRR takimi kolektywnymi gospodarstwami były
                <span class="my-tooltip">
                  kołchozy
                  <span class="tooltiptext">
                    Ros. колхоз, skrót od коллективное хозяйство (kollektiwnoje
                    choziajstwo), czyli gospodarstwo wspólnotowe
                  </span>
                </span>
                i
                <span class="my-tooltip">
                  sowchozy
                  <span class="tooltiptext">
                    Ros. совхоз, skrót od советское хозяйство (sowietskoje
                    choziajstwo), czyli gospodarstwo radzieckie.
                  </span>
                </span>
                Kolektywizacja wymagała jednak odebrania polskim chłopom ziemi –
                tej ziemi, którą władze komunistyczne obiecały im w Manifeście
                Polskiego Komitetu Wyzwolenia Narodowego z lipca 1944 roku, i
                którą im rzeczywiście przekazały podczas reformy rolnej na mocy
                dekretu PKWN z września tego samego roku.
              </p>
            </div>
            <div
              class="section-img"
              :class="{ enlarged: isEnlarge == 1 }"
              @click="toogleEnlarge(1)"
            >
              <img
                class=""
                :src="require('../assets/scenariusze/img/img1.png')"
                alt="image1"
              />
              <div class="img-info">
                Rys. 1. Jeszcze w 1955 roku prasa przedstawiała idylliczny obraz
                polskich kołchozów, czyli rolniczych spółdzielni produkcyjnych
                (zdjęcie z „Zielonego Sztandaru” z kwietnia 1955 roku)
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <h4 class="title">Czy było to zdarzenie nowe w historii Polski?</h4>
          <div class="content">
            <div class="section-body">
              <p>
                Warto przypomnieć, że w 1944 roku rękami polskich kolaborantów
                (albowiem PKWN realizował interesy władz ZSRR) Sowieci
                powtórzyli manewr, który carat wykonał w 1864 roku podczas
                <span class="my-tooltip">
                  powstania styczniowego
                  <span class="tooltiptext">
                    Jedno z dwóch największych polskich powstań narodowych w XIX
                    wieku. Trwało od stycznia 1863 roku do jesieni 1864 roku i
                    objęło ziemie Królestwa Polskiego oraz Litwy (zabór
                    rosyjski). Miało charakter wojny partyzanckiej. Mimo porażki
                    militarnej i masowych represji ze strony caratu (konfiskaty
                    mienia, zesłania, egzekucje), powstanie spowolniło proces
                    rusyfikacji ludności, przyczyniając się do podtrzymania
                    tożsamości narodowej Polaków.
                  </span> </span
                >. Ogłoszono wtedy koniec pańszczyzny i uwłaszczenie chłopstwa w
                istniejącym formalnie Królestwie Polskim (tzw. Królestwo
                Kongresowe), zniechęcając najliczniejszą warstwę społeczeństwa
                polskiego do angażowania się w ruch narodowowyzwoleńczy. W roku
                1944 Sowietom w ten sam sposób udało się osłabić społeczne
                poparcie dla
                <span class="my-tooltip">
                  legalnych władz Rzeczpospolitej
                  <span class="tooltiptext">
                    Legalną władzą Rzeczpospolitej Polskiej w 1944 roku był Rząd
                    na uchodźstwie, reprezentowany przez administrację cywilną
                    (Delegatura Rządu na Kraj) i dysponujący oddziałami Armii
                    Krajowej.
                  </span> </span
                >, zyskując przychylność tej części chłopstwa, której komuniści
                obiecali przekazać na własność „ziemię obszarniczą” po
                parcelacji – oczywiście w zamian za poparcie. W rzeczywistości
                komunizm w wydaniu sowieckim bezwzględnie zwalczał własność
                prywatną ziemi i środków produkcji, a ukrytym celem
                przeprowadzenia reformy rolnej w Polsce było zniszczenie warstwy
                ziemiańskiej – wykształconej i podtrzymującej tradycje
                niepodległościowe.
              </p>
            </div>
            <div
              class="section-img"
              :class="{ enlarged: isEnlarge == 3 }"
              @click="toogleEnlarge(3)"
            >
              <img
                class=""
                :src="require('../assets/scenariusze/img/img3.png')"
                alt="image1"
              />
              <div class="img-info">
                Rys. 2. Pierwsza strona carskiego aktu uwłaszczenia chłopów w
                Królestwie Polskim z 1864 roku.
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <h4>Jak wyglądała kolektywizacja na ziemiach polskich?</h4>
          <div class="content">
            <div class="section-body">
              <p>
                Gdy komuniści zdobyli w Polsce pełnię władzy politycznej, co
                nastąpiło pod koniec 1948 roku, energicznie przystąpili do
                kolektywizacji wsi. Jednak naiwnością byłoby sądzić, że polskim
                chłopom można po prostu zabrać to, co się im wcześniej dało. Tym
                bardziej że władza nie chciała zbyt ostentacyjnie wycofywać się
                ze swoich wcześniejszych obietnic. Dlatego ówcześni
                propagandyści zastosowali stary jak świat zabieg „zmiany
                etykiet”, polegający na nazwaniu planowanego deliktu w sposób
                niebudzący niepożądanych skojarzeń. I tak słowo ‘kolektywizacja’
                zastąpiono rozwojem ‘gospodarki spółdzielczej’, a ‘kołchoz’ –
                ‘rolniczą spółdzielnią produkcyjną’. Na tej samej zasadzie w
                publicznym dyskursie państw totalitarnych ‘zabijanie’
                zastępowano ‘eliminacją’ czy ‘likwidacją’, ‘strajki’ –
                ‘przerwami w pracy’, a ‘reżim totalitarny’ – ‘demokracją
                ludową’. Władze komunistyczne zawłaszczyły więc pozytywnie
                nacechowane słownictwo i wykorzystały piękną tradycję prawdziwej
                spółdzielczości, przez pokolenia tworzonej oddolnie m.in. pod
                egidą Polskiej Partii Socjalistycznej. Można przy okazji dodać,
                że rodzący się wówczas nowy język państwa totalitarnego
                określany jest w literaturze przedmiotu jako

                <span class="my-tooltip">
                  nowomowa
                  <span class="tooltiptext">
                    Zniekształcony język publiczny państw totalitarnych, w
                    szczególności komunistycznych i faszystowskich.
                  </span>
                </span>
                Aby jednak operację kolektywizacji przeprowadzić sprawnie, na
                wsi potrzebna była intensywna agitacja, którą prowadzili
                przedstawiciele władzy, korzystając z pomocy ówczesnej prasy.
                Właśnie ten wymiar kolektywizacji można dość dokładnie
                prześledzić metodami analizy korpusowej, korzystając z zasobów i
                narzędzi ChronoPressu.
              </p>
            </div>
            <div
              class="section-img"
              :class="{ enlarged: isEnlarge == 2 }"
              @click="toogleEnlarge(2)"
            >
              <img
                class=""
                :src="require('../assets/scenariusze/img/img2.png')"
                alt="image1"
              />
              <div class="img-info">
                Rys. 3. Manifest lipcowy – polski, a de facto sowiecki, dekret
                PKWN, w którym znalazła się m.in. zapowiedź nadania ziemi
                chłopom (1944)
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <h4 class="title">
            Jak korpus tekstów może pomóc w zrozumieniu tego zjawiska?
          </h4>
          <div class="content">
            <div class="section-body wide">
              <p>
                Korpus prasy ChronoPress zawiera reprezentację dyskursu
                prasowego okresu Polski Ludowej (w przygotowaniu lata 1944–1990,
                a docelowo 1918–2018). Badając frekwencje niektórych wyrazów lub
                ich zbiorów (tematyczne pola leksykalne, zwane czasem
                kohortami), można dosłownie i w przenośni wyświetlić dynamikę
                zjawisk społecznych i gospodarczych. I tak na przykład analiza
                wystąpień
                <span class="my-tooltip">
                  leksemów
                  <span class="tooltiptext">
                    Leksem w praktyce lingwistycznej jest zbiorem wyrazów
                    należących do paradygmatu odmiany danego wyrazu – tutaj jest
                    to ‘spółdzielnia’ lub ‘spółdzielczy’. Na leksem
                    ‘spółdzielnia’ składają się więc formy wyrazowe
                    ‘spółdzielnia’, ‘spółdzielnie’, ‘spółdzielni’,
                    ‘spółdzielniami’ etc.
                  </span>
                </span>

                ‘spółdzielnia’ lub ‘spółdzielczy’ ujawnia realną siłę i dynamikę
                presji wywieranej przez aparat władzy na kolektywizację polskiej
                wsi.
              </p>
              <p>
                Przedstawiony wykres został wygenerowany funkcją szeregu
                czasowego z portalu ChronoPress. Zsumowano frekwencję leksemów
                ‘spółdzielnia’ i ‘spółdzielczy’ z lat 1945–1963. Moduł szeregów
                czasowych umożliwia analizę zjawisk przy interwałach rocznych i
                miesięcznych, a wybór powinien być podyktowany jedynie
                frekwencją leksemów i oczekiwaniami co do szczegółowości wyniku.
              </p>
              <p>
                Wykresy 1 i 1a ujawniają, że presja medialna na chłopstwo,
                zachęcane wszelkimi argumentami do zrzekania się własności ziemi
                i wnoszenia jej do majątku spółdzielni (a więc w praktyce
                kolektywizacja) rozpoczyna się tuż po wojnie, stopniowo rośnie,
                by osiągnąć apogeum w latach 1953–1954, a następnie gwałtownie
                spada do niskiego poziomu. Władze uświadamiają sobie wówczas, że
                przeniesienie sowieckiego wzorca kolektywizacji na polski grunt
                nie jest możliwe. Z przedsięwzięcia trzeba więc zrezygnować,
                ponieważ braki żywności w dawnym spichlerzu Europy, spowodowane
                niską efektywnością modelu kolektywistycznego, mogłyby
                doprowadzić do masowych protestów społecznych (czego przykładem
                był Poznański Czerwiec 1956). W konsekwencji tych zdarzeń Polska
                mogła zacząć budować socjalizm o specyfice narodowej – mniej
                ortodoksyjnej i destrukcyjnej dla całokształtu życia
                społecznego. Oficjalnym potwierdzeniem tej zmiany była zgoda
                Sowietów na powierzenie władzy w PRL Władysławowi Gomułce, który
                objął funkcję I sekretarza KC PZPR w październiku 1956 r. Z
                perspektywy lat można powiedzieć, że opór społeczny polskiej wsi
                uratował Polskę przed konsekwencjami kolektywizacji przymusowej,
                jaką Sowieci narzucili Ukrainie w latach trzydziestych,
                doprowadzając do głodowej śmierci wielu milionów ofiar (tzw.
                hołodomor).
              </p>
            </div>
          </div>
          <div class="chart">
            <div class="chart-img">
              <img
                class=""
                :src="require('../assets/scenariusze/img/img4.png')"
                alt="image1"
              />
            </div>
            <div class="chart-text">
              <i>
                Wykres 1. Histogram zsumowanej frekwencji leksemów
                ‘spółdzielnia’ i spółdzielczy’ (interwały roczne)
              </i>
            </div>
          </div>

          <div class="chart">
            <div class="chart-img">
              <img
                class=""
                :src="require('../assets/scenariusze/img/img5.png')"
                alt="image1"
              />
            </div>
            <div class="chart-text">
              <i>
                Wykres 1a. Histogram zsumowanej frekwencji leksemów
                ‘spółdzielnia’ i spółdzielczy’ (interwały miesięczne)
              </i>
            </div>
          </div>
        </div>
        <div class="section">
          <h4>Czy dane korpusowe pozawalają na interpretacje jakościowe?</h4>
          <div class="content">
            <div class="section-body wide">
              <p>
                Jest faktem, że korpus oparty na reprezentacji publikacji
                prasowych nie jest biblioteką cyfrową i nie pełni funkcji
                typowej kolekcji dokumentów. Daje wgląd jedynie w losowo wybrane
                fragmenty gazet i czasopism. Cytaty takie dostępne są jednak w
                dużej liczbie i technikami
                <span class="my-tooltip"
                  >text mining
                  <span class="tooltiptext">
                    Text mining jest zbiorem technik ekscerpcji (wydobywania) i
                    analizy informacji z nieustrukturyzowanych korpusów tekstów.
                    Posługuje się algorytmami, wykorzystującymi zarówno proste
                    narzędzia statystyczne, jak i zaawansowane rozwiązania
                    sztucznej inteligencji.
                  </span>
                </span>
                można stosunkowo łatwo wydobyć z nich wiele cennych informacji,
                których pozyskanie w sposób tradycyjny zajęłoby zbyt wiele
                czasu. Oprócz parametrów ilościowych korpus ChronoPress
                dostarcza więc syntetycznych danych, ułatwiających zrozumienie i
                interpretację zjawisk, o których prasa mówi wprost, a także
                tych, które ukryte są w tle.
              </p>
            </div>
          </div>
        </div>

        <div class="section">
          <h4 class="title">Do czego służy analiza konkordancji?</h4>
          <div class="content">
            <div class="section-body wide">
              <p>
                Kliknięcie w punkt na wykresie szeregu czasowego (histogramu)
                uruchamia wyszukiwarkę
                <span class="my-tooltip"
                  >konkordancji
                  <span class="tooltiptext">
                    Konkordancja we współczesnej statystyce leksykalnej jest
                    listą wystąpień leksemu bądź formy wyrazowej w kontekstach
                    wraz z odwołaniami do źródła cytatu. W historii
                    przetwarzania danych początków traktowania konkordancji
                    należy szukać w ponadtysiącletniej praktyce badań Pisma
                    Świętego (egzegeza). Pierwsze konkordancje biblijne były
                    zestawieniami wyrazów powtarzających się czterech
                    Ewangeliach, tworzących kanon chrześcijaństwa. Zamiast (a
                    niekiedy oprócz) bezpośredniego kontekstu użycia ich autorzy
                    podawali nazwę ewangelii i numer wersu, w którym dany wyraz
                    wystąpił.
                  </span> </span
                >. Czytając krótkie konteksty wystąpienia konkretnego wyrazu
                (tzw. ośrodka konkordancji), można szybko zorientować się w jego
                semantyce i wydźwięku. Tabela zamieszczona poniżej przedstawia
                konkordancję leksemu ‘spółdzielnia’ w korpusie ChronoPress.
                Konkordancje można też generować i eksportować w postaci pliku
                bezpośrednio z modułu ‘Konkordancje’. Jeżeli dane wyświetlone na
                ekranie nie wystarczają do zrozumienia kontekstu użycia wyrazu,
                kliknięcie w poszczególne linie pozwala wyświetlić całe
                fragmenty wraz z metadanymi.
              </p>
            </div>
          </div>
          <div class="chart">
            <div class="chart-img">
              <img
                class=""
                :src="require('../assets/scenariusze/img/img6.png')"
                alt="image1"
              />
            </div>
            <div class="chart-text">
              <i>
                Tab. 1 Fragment konkordancji leksemu ‘spółdzielnia’ w korpusie
                prasowym
              </i>
            </div>
          </div>
        </div>
        <div class="section">
          <h4>Do czego służą profile wyrazów/pojęć?</h4>
          <div class="content">
            <div class="section-body wide">
              <p>
                Konteksty występujące na liście konkordancji mogą zostać
                oczywiście przeczytane przez człowieka. Kiedy jednak ich liczba
                jest duża, a w dodatku szuka się w nich mierzalnych i
                obiektywnie porównywalnych prawidłowości, łatwiej jest poddać je
                analizie automatycznej.
              </p>
              <p>
                Wykresy poniżej ukazują profile semantyczne leksemu
                ‘spółdzielnia’. Wartości wyświetlone są odsetkiem kolejnych
                wyrazów pojawiających się najczęściej w lewym i prawym
                kontekście ośrodka konkordancji (czyli leksemu ‘spółdzielnia’) w
                odległości od 1 do 3 wyrazów. Podczas profilowania wskazane jest
                określenie części mowy kontekstu (tutaj przymiotnik jako część
                mowy najlepiej odpowiadająca semantycznej funkcji
                charakteryzowania rzeczownika). Interpretacja tych wyników
                ujawnia silną presję propagandową na kolektywizację wsi.
                Widoczna jest absolutna dominacja przymiotnika ‘produkcyjny’
                oraz leksemów ‘gminny’ i ‘chłopski’, a także brak leksemów
                kojarzących się z ruchem spółdzielczym w miastach, popularnym
                przed wojną. Nie występują także połączenia ‘spółdzielni’ z
                przymiotnikiem ‘mieszkaniowy’ – typowe dla okresów późniejszych.
              </p>
              <div class="chart">
                <div class="chart-img">
                  <img
                    class=""
                    :src="require('../assets/scenariusze/img/img7.png')"
                    alt="image1"
                  />
                </div>
                <div class="chart-text">
                  <i>
                    Wykres 2. Profil semantyczny leksemu ‘spółdzielnia’
                    (przymiotniki, dwa formaty)
                  </i>
                </div>
              </div>

              <p>
                <br />
                Powyższe podejście do analizy kontekstu nie jest jedynym,
                premiuje bowiem typowość (czyli wysokie frekwencje) połączeń
                wyrazowych, a nie ich wyjątkowość czy specyficzność w stosunku
                do języka ogólnego (czyli statystycznego wzorca przeciętności).
                Istnieją również analizatory kontekstu rozpoznające
                automatycznie połączenia nietypowe czy w jakiś sposób
                oryginalne. Wybór zastosowanego narzędzia zależny jest od
                postawionego pytania i oczekiwań badacza (w przypadku
                ChronoPressu jest to typowość).
              </p>
            </div>
          </div>
        </div>
        <div class="section">
          <h4>Kiedy dane korpusowe są niezastąpione?</h4>
          <div class="content">
            <div class="section-body wide">
              <p>
                Profile leksykalne można wyznaczać nie tylko z korpusu, ale
                także metodą ankietową, zwracając się do grupy respondentów
                (typowe pytanie: Wypisz przymiotniki, które kojarzą ci się z
                wyrazem ‘spółdzielnia’). Otrzymujemy wtedy uśredniony obraz
                mentalny danego pojęcia czy przedmiotu. Jednak obraz taki jest
                zawsze współczesny ludziom, którzy są w danym momencie pytani. A
                jak postąpić w przypadku, gdy interesują nas czasy minione,
                których potomni nie znają z autopsji? Z pomocą przychodzi
                właśnie analiza korpusowa, która daje możliwość odkrycia profilu
                pojęcia wyłącznie na podstawie tekstów. ChronoPress
                odzwierciedla czasy leżące częściowo lub całkowicie poza
                zasięgiem pamięci współczesnych, ale pozostające w orbicie ich
                zainteresowań. Dzięki narzędziom automatycznego przetwarzania
                języka profilowanie pojęć jest w takiej sytuacji łatwe, ponieważ
                opiera się wyłącznie na badaniu

                <span class="my-tooltip"
                  >dystrybucji
                  <span class="tooltiptext">
                    Dystrybucję danego wyrazu tworzą jednostki okalające go z
                    lewej i/lub prawej strony w linii tekstu.
                  </span>
                </span>

                leksemów w tekstach.
              </p>
            </div>
          </div>
        </div>
        <!-- KOLEKTYWIZACJA END -->
      </div>
      <!-- SCHEMAT KATASTROFY -->
      <div class="case-body" :class="{ 'case-active': activeCase == 2 }">
        <div class="highlight">
          <h2>Scenariusz w trakcie przygotowania...</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FadeTransition from "@/components/FadeTransition.vue";
import SideTabs from "../components/SideTabs.vue";

export default {
  name: "Home",
  components: {
    FadeTransition,
    SideTabs,
  },
  data() {
    return {
      list: [],
      isEnlarge: 0,
      modalVisible: false,
      showCorpus: false,
      showPRL: false,
      showTeam: false,
      showUsage: false,
      activeCase: 1,
      images: [
        'require("../assets/scenariusze/img/img1.png")',
        "../assets/scenariusze/img/img1.png",
        "../assets/scenariusze/img/img1.png",
        "../assets/scenariusze/img/img1.png",
        "../assets/scenariusze/img/img1.png",
        "../assets/scenariusze/img/img1.png",
        "../assets/scenariusze/img/img1.png",
      ],
    };
  },
  methods: {
    redirectUser: function (path) {
      this.$router.push(path);
    },
    resetSection() {
     
      this.showCorpus = false;
      this.showTeam = false;
      this.showPRL = false;
    },
    toggleModal(section) {
      this.resetSection();
      this.modalVisible = !this.modalVisible;
      if (section === "Corpus") {
        this.showCorpus = true;
    
      } else if (section === "Tools") {
        this.showTools = true;
      
      } else if (section === "Team") {
        this.showTeam = true;
      
      } else if (section === "PRL") {
        this.showPRL = true;
        
      }
    },
    selectCase(case_nb) {
      this.activeCase = case_nb;
      
    },
    toogleEnlarge(int) {
      if (this.isEnlarge != 0) {
        this.isEnlarge = 0;
        return;
      }
      this.isEnlarge = int;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.main {
  background-color: rgb(255, 255, 255);
  overflow-x: hidden;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 0;
  padding-top: 0;
}
.action-buttons {
  display: flex;
  float: right;
  margin-right: 2rem;
}
.action-btn {
  margin-right: 1rem;
  width: 2rem;
  height: 2rem;
  color: black;
  background-color: rgb(255, 255, 255);
  border: 2px solid black;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.case-body {
  display: none;
}
.case-active {
  display: block;
}
.case-container {
  width: 75%;
  height: fit-content;
  margin-top: 3rem;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}
.case-container h2 {
  display: inline;
  margin-right: 3rem;
}
.tab-list {
  display: inline-flex;
}
.tab {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 10rem;
  max-height: 2rem;
  margin-left: -1rem;
  padding-left: 2rem;
  padding-right: 1rem;
  border-radius: 0 15px 0 0;
  box-shadow: 5px -4px 5px rgba(0, 0, 0, 0.438);
  border: none;
  background-color: white;
}
.tab:hover {
  color: white;
  background-color: rgb(39, 39, 39);
}
.active-tab {
  background-color: rgb(232, 232, 232);
}
#sc-1 {
  z-index: 6;
}
#sc-2 {
  z-index: 5;
}
#sc-3 {
  z-index: 4;
}
#sc-4 {
  z-index: 3;
}
.case-body {
  background-color: rgb(255, 255, 255);
  min-height: 100%;
  height: fit-content;
  width: 71%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4rem;
}
.section {
  padding: 1rem;
  width: 100%;
}
.section > h4 {
  font-weight: bold;
}
.content {
  display: block;
  align-items: flex-start;
  width: 100%;
}
.section-body {
  width: 100%;
  text-align: justify;
}
.wide {
  width: 100%;
  justify-content: center;
  align-items: center;
}
.section > .content > .section-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 1.5rem;
}
.section-img img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  cursor: pointer;
  width: 60%;
}
.img-info {
  font-size: 0.9rem;
  width: 80%;
}
.enlarged {
  z-index: 9999;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw !important;
  height: 100vh;
  margin-left: auto;
  margin-right: auto;
  margin: 0 !important;
  padding: 5%;
  background-color: #ffffffd2;
  transition: all 0.3s ease-in-out;
}
.chart {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
}
.chart-img {
  width: 100%;
}
.small {
  width: 50%;
}
.chart-img img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.chart-text {
  text-align: center;
  font-size: 0.9rem;
}
.highlight {
  color: #803f17;
  background-color: #febf94;
}
.highlight h2 {
  font-size: 2.2rem;
  font-weight: bold;
  padding-left: 2rem;
}

.my-tooltip {
  cursor: pointer;
  position: relative;
  display: inline-block;
  color: #ff8839;
  border-bottom: 1px dotted black;
  border-radius: initial;
}
.my-tooltip .tooltiptext {
  visibility: hidden;
  width: 300px;
  background-color: rgb(255, 255, 255);
  border: 2px solid #292929;
  color: rgb(0, 0, 0);
  text-align: center;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 150%;
  left: 50%;
  margin-left: -150px;
  text-align: justify;
  text-justify: inter-character;
  padding: 1rem;
  font-weight: normal;
}
.my-tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}
.my-tooltip:hover {
  color: black;
  background-color: #febf94;
}
.my-tooltip:hover .tooltiptext {
  visibility: visible;
}
@media only screen and (max-width: 768px) {
  .modal-body {
    margin: 0 5vw !important;
  }
  .modal-body span {
    width: 100%;
  }
}
.about-modal {
  z-index: 9999;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.534);
}
.modal-body {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40%;
  max-height: 80%;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 5px 15px #0f0f0fdd;
  margin: 0 15vw;
  padding-top: 4rem;
  overflow: hidden;
}
.modal-close-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 3rem;
  height: 3rem;
  color: rgb(105, 105, 105);
  background-color: white;
  border: none;
  outline: none;
  font-weight: bold;
}
.modal-close-btn:hover {
  font-size: 1.2rem;
}
.home-content {
  display: none;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(199, 199, 199, 0.467);
  margin-bottom: 0rem;
}
.about {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
  height: 80%;
  margin-top: 2rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  margin-bottom: 3rem;
  margin-bottom: 1rem;
  background-color: rgba(255, 255, 255, 0.542);
}
.about-text {
  width: 80%;
  padding-left: 1vw;
  padding-right: 1vw;
  padding-bottom: 1rem;
  background-color: rgb(255, 255, 255);
  overflow-y: auto;
}
.about-text p {
  text-justify: inter-character;
  text-align: justify;
  font-size: 1rem;
}
.about p {
  text-justify: newspaper;
}
.about-text span p {
  text-justify: newspaper;
}
.section-body p {
  font-size: 20px;
}
</style>

<style>
.main {
  min-height: calc(100vh - 120px) !important;
  width: 100% !important;
}
@media only screen and (max-width: 769px) {
  .hover-buttons {
    margin-top: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Cases.vue